<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Integrations') }}</h4>
        </div>
      </div>
    </div>

    <div class="vflex-row-1 p-3">
      <creating
        v-if="creating"
        height="100%" />
      <div
        class="shurt-conatiner"
        v-if="!creating"
        :class="{'box-loading': loading}">
        <ul
          class="list-group"
          style="max-width: 800px">
          <IntegrationItem
            v-for="(item, index) in items"
            :key="index"
            :keyName="item.key"
            :urlImg="item.url_img"
            :title="item.title"
            :description="item.description"
            :integration="item.integration"
            @removed="loadData"
            @saved="loadData" />
        </ul>
      </div>
    </div>

  </div>

</template>

<script>
import IntegrationItem from './IntegrationItem'

export default {
  name: 'Integration',
  components: {
    IntegrationItem
  },
  data () {
    return {
      creating: true,
      loading: true,
      modal_select: false,
      sort: 'name',
      selected: [],
      options: []
    }
  },
  computed: {
    integrations () {
      return this.$store.getters.getIntegrations
    },
    account () {
      return this.$store.getters.getAccount
    },
    items () {
      return this.options.map(option => {
        return {
          ...option,
          integration: this.integrations.find(v => v.key === option.key) || {}
        }
      })
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      this.axios.get('/accounts/' + this.$store.getters.getAccount._id + '/integrations/options').then(res => {
        this.options = res.data
        return Promise.all([
          this.$store.dispatch('setIntegrationSummaries'),
          this.$store.dispatch('selectIntegrations')
        ])
      })
      .then((result) => {
        this.loading = this.creating = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/Integration.vue